import styled from 'styled-components'

import { Image } from '@ui/blocks/Image'

import { SocialIcon, SocialIconsWrapper } from './SocialIcons'

export const ArticleHeading = styled.div`
  margin: 7rem auto 4rem auto;
  text-align: center;
  max-width: 88rem;
`

export const ArticleMeta = styled.div`
  margin-top: 2.6rem;
  justify-content: center;
  align-content: center;
  text-transform: uppercase;

  ul {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const Separator = styled.span`
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  margin: 0 1.6rem;
  display: inline-block;
  position: relative;
  bottom: 0.2rem;
  background-color: ${({ theme }) => theme.global.colors.elemyGreen};
`
export const ArticleBody = styled.article`
  margin: 0 auto;
  max-width: 57rem;
  position: relative;
`

export const ArticleImg = styled(Image)`
  margin-bottom: 1.6rem;
  object-fit: contain;
  max-width: 57rem;

  @media ${({ theme }) => theme.device.mobileM} {
    display: none;
  }
`

export const ArticleText = styled.section`
  position: relative;

  p {
    margin: 2.4rem 0;
  }

  h2 {
    margin: 2.4rem 0;
    font-family: ${({ theme }) => `${theme.global.fontNames.serif}`};
    font-feature-settings: 'pnum' on, 'lnum' on, 'liga' 1;
    color: ${({ theme }) => `${theme.global.colors.elemyGreen}`};
    font-size: 3.2rem;
    line-height: 4.4rem;
    font-weight: 500;
    letter-spacing: 0;

    @media ${({ theme }) => theme.device.tablet} {
      font-size: 3.2rem;
      line-height: 4.4rem;
    }

    @media ${({ theme }) => theme.device.mobileS} {
      font-size: 2.6rem;
      line-height: 3.4rem;
    }
  }

  ul {
    padding-left: 3rem;
  }

  li {
    list-style: disc;
  }

  a {
    color: ${({ theme }) => theme.global.colors.genoa};
  }
`

export const DesktopSocial = styled.div`
  position: absolute;
  top: 32rem;
  left: -10rem;

  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`
export const MobileSocial = styled.div`
  margin: 4rem auto;
  display: none;
  justify-content: center;

  @media ${({ theme }) => theme.device.tablet} {
    display: flex;
  }

  ${SocialIconsWrapper} {
    flex-direction: row;

    ${SocialIcon} {
      &:first-child {
        margin: 0 2rem 0 0;
      }
    }
  }
`
